export const admin = {
  'admin.title': 'Admin Dashboard',
  'admin.subtitle': 'Manage subsidies, farms, and system settings',
  'admin.devEnv': 'Development Environment - Additional features enabled',
  'admin.accessDenied': 'Access Denied',
  'admin.loginRequired': 'You must be logged in to access the admin panel.',
  'admin.permissionDenied': 'You don\'t have permission to access the admin panel.',
  'admin.onlyAdmins': 'Only administrators can access this section.',
  'admin.devMode': 'Development mode: Admin access is restricted to configured emails.',

  // Import Management
  'admin.import.title': 'Data Import',
  'admin.import.subtitle': 'Import subsidies, farms, and applications in bulk',
  'admin.import.dataType': 'Data Type',
  'admin.import.file': 'File (CSV, Excel, JSON)',
  'admin.import.selected': 'Selected',
  'admin.import.parsePreview': 'Parse and Preview',
  'admin.import.fieldMapping': 'Field Mapping',
  'admin.import.fieldMappingDesc': 'Map your file columns to the canonical data fields',
  'admin.import.skipField': 'Skip this field',
  'admin.import.validateData': 'Validate Data',
  'admin.import.validationResults': 'Validation Results',
  'admin.import.validRecords': 'Valid Records',
  'admin.import.warnings': 'Warnings',
  'admin.import.errors': 'Errors',
  'admin.import.duplicatesFound': 'Found {count} potential duplicates. Review before importing.',
  'admin.import.issuesFound': 'Issues Found:',
  'admin.import.moreIssues': '... and {count} more issues',
  'admin.import.startOver': 'Start Over',
  'admin.import.importRecords': 'Import {count} Records',
  'admin.import.progress': 'Import Progress',
  'admin.import.processed': 'Processed',
  'admin.import.success': 'Success',
  'admin.import.failed': 'Failed',
  'admin.import.completed': 'Import completed successfully! {count} records imported.',
  'admin.import.downloadTemplates': 'Download Templates',
  'admin.import.history': 'Import History',
  'admin.import.templates': 'Templates & Documentation',
  'admin.import.historyComingSoon': 'Import history functionality coming soon...',
  'admin.import.templatesComingSoon': 'Download templates and view documentation...',

  // Validation Messages
  'admin.validation.fileEmpty': 'File is empty or could not be parsed',
  'admin.validation.unsupportedFormat': 'Unsupported file format',
  'admin.validation.invalidJSON': 'Invalid JSON format',
  'admin.validation.required': 'This field is required',
  'admin.validation.invalidType': 'Invalid data type',
  'admin.validation.duplicateFound': 'Duplicate value found',
  'admin.validation.invalidDate': 'Invalid date format',
  'admin.validation.invalidNumber': 'Invalid number format',
  'admin.validation.invalidURL': 'Invalid URL format',

  // Toasts
  'admin.toast.importFailed': 'Import Failed',
  'admin.toast.validationErrors': 'Validation Errors',
  'admin.toast.validationComplete': 'Validation Complete',
  'admin.toast.recordsReady': '{count} records ready for import',
  'admin.toast.importComplete': 'Import Complete',
  'admin.toast.recordsImported': 'Successfully imported {success} records. {failed} failed.',
  'admin.toast.unknownError': 'Unknown error occurred',
  'admin.toast.errorsFound': 'Found {count} errors that must be fixed',

  // Admin Features for Settings Page
  'admin.tierSimulator.title': 'Tier Simulator',
  'admin.tierSimulator.description': 'Test different subscription tiers (Discover, Solo, Pro, Enterprise)',
  'admin.employee.title': 'Employee Dashboard',
  'admin.employee.description': 'Management tools for employees and team members',
  'admin.dataQuality.title': 'Data Quality',
  'admin.dataQuality.description': 'Monitor and improve subsidy data quality',
  'admin.panel.title': 'Admin Panel',
  'admin.panel.description': 'Main administration panel and system management tools',
  'admin.devTools.title': 'Development Tools',
  'admin.devTools.description': 'Development and debugging tools for developers',

  // Admin Review Dashboard
  'admin.placeholders.addReviewNotes': 'Add your review notes...',

  // AI Testing Control
  'admin.placeholders.leaveEmptyForAutoGenerate': 'Leave empty for auto-generate',

  // Subsidy Document Extractor
  'admin.placeholders.enterPdfUrl': 'Enter PDF URL to test extraction...',

  // Consultant Verification
  'admin.placeholders.explainRejection': 'Explain why this profile is rejected...',

  // AI Field Classifier
  'admin.placeholders.enterFieldName': 'Enter field name...',

  // URL Health Dashboard
  'admin.placeholders.searchSubsidiesOrUrls': 'Search subsidies or URLs...',

  // Admin V2 - New lean admin dashboard
  'adminV2.title': 'Subvention360 Admin',
  'adminV2.signIn.title': 'Admin Access',
  'adminV2.signIn.subtitle': 'Sign in to access the admin dashboard',
  'adminV2.signIn.email': 'Email',
  'adminV2.signIn.password': 'Password',
  'adminV2.signIn.button': 'Sign In',
  'adminV2.signIn.signingIn': 'Signing in...',
  'adminV2.signIn.error': 'Invalid email or password',
  'adminV2.verifying': 'Verifying admin access...',
  'adminV2.redirecting': 'Redirecting...',
  'adminV2.logout': 'Logout',

  // Admin V2 Navigation
  'adminV2.nav.kpis': 'KPIs',
  'adminV2.nav.commercial': 'Commercial',
  'adminV2.nav.users': 'Users',
  'adminV2.nav.profiles': 'Profiles',
  'adminV2.nav.data': 'Data',
  'adminV2.nav.health': 'Health',
  'adminV2.nav.content': 'Content',
  'adminV2.nav.subsidies': 'Subsidies',
  'adminV2.nav.blog': 'Blog',

  // Admin V2 Commercial Dashboard
  'adminV2.commercial.title': 'Commercial Dashboard',
  'adminV2.commercial.subtitle': 'Conversion funnel & revenue metrics',
  'adminV2.commercial.loading': 'Loading metrics...',
  'adminV2.commercial.error': 'Failed to load analytics',
  'adminV2.commercial.errorHint': 'Make sure POSTHOG_PERSONAL_API_KEY and POSTHOG_PROJECT_ID are set in Supabase secrets.',
  'adminV2.commercial.retry': 'Retry',
  'adminV2.commercial.openPostHog': 'Open PostHog',
  'adminV2.commercial.trialSignups': 'Trial Signups',
  'adminV2.commercial.trialConversion': 'Trial Conversion',
  'adminV2.commercial.standardSignups': 'Standard Signups',
  'adminV2.commercial.overallConversion': 'Overall Conversion',
  'adminV2.commercial.completed': 'completed',
  'adminV2.commercial.trialToPaid': 'Trial to paid',
  'adminV2.commercial.onboardingFunnel': 'Onboarding Funnel',
  'adminV2.commercial.stepConversion': 'Step-by-step conversion',
  'adminV2.commercial.abandonmentReasons': 'Abandonment Reasons',
  'adminV2.commercial.whyDropOff': 'Why users drop off',
  'adminV2.commercial.noFunnelData': 'No funnel data available',
  'adminV2.commercial.noAbandonmentData': 'No abandonment data',
  'adminV2.commercial.dailyActivity': 'Daily Activity',
  'adminV2.commercial.signupsOverTime': 'Signups over time',
  'adminV2.commercial.noDailyData': 'No daily data available',
  'adminV2.commercial.date': 'Date',
  'adminV2.commercial.started': 'Started',
  'adminV2.commercial.abandoned': 'Abandoned',
  'adminV2.commercial.period24h': '24h',
  'adminV2.commercial.period7d': '7 days',
  'adminV2.commercial.period30d': '30 days',

  // Admin V2 Commercial - Stripe Revenue
  'adminV2.commercial.revenueMetrics': 'Revenue Metrics',
  'adminV2.commercial.revenueSubtitle': 'Stripe payment & subscription data',
  'adminV2.commercial.totalRevenue': 'Total Revenue',
  'adminV2.commercial.balance': 'Balance',
  'adminV2.commercial.pending': 'pending',
  'adminV2.commercial.customers': 'Customers',
  'adminV2.commercial.invoices': 'Invoices Paid',
  'adminV2.commercial.overdue': 'overdue',
  'adminV2.commercial.mrr': 'Monthly Recurring Revenue',
  'adminV2.commercial.activeSubscriptions': 'Active Subscriptions',
  'adminV2.commercial.trialUsers': 'Trial Users',
  'adminV2.commercial.inTrial': 'in trial',
  'adminV2.commercial.churnRate': 'Churn Rate',
  'adminV2.commercial.thisMonth': 'this month',
  'adminV2.commercial.canceledThisMonth': 'canceled this month',
  'adminV2.commercial.customersByTier': 'Customers by Tier',
  'adminV2.commercial.volumeDistribution': 'Volume tier distribution',
  'adminV2.commercial.noTierData': 'No tier data available',
  'adminV2.commercial.recentTransactions': 'Recent Transactions',
  'adminV2.commercial.latestPayments': 'Latest payments received',
  'adminV2.commercial.noTransactions': 'No recent transactions',
  'adminV2.commercial.stripeNotConfigured': 'Stripe not configured',
  'adminV2.commercial.stripeHint': 'Make sure STRIPE_SECRET_KEY is set in Supabase secrets.',
  'adminV2.commercial.openStripe': 'Open Stripe',

  // Admin V2 Commercial - Traffic Analytics
  'adminV2.commercial.trafficAnalytics': 'Traffic Analytics',
  'adminV2.commercial.trafficSubtitle': 'Page views, performance & engagement',
  'adminV2.commercial.pageViews': 'Page Views',
  'adminV2.commercial.uniqueUsers': 'unique users',
  'adminV2.commercial.lcp': 'LCP',
  'adminV2.commercial.lcpDesc': 'Largest Contentful Paint',
  'adminV2.commercial.cls': 'CLS',
  'adminV2.commercial.clsDesc': 'Cumulative Layout Shift',
  'adminV2.commercial.inp': 'INP',
  'adminV2.commercial.inpDesc': 'Interaction to Next Paint',
  'adminV2.commercial.topPages': 'Top Pages',
  'adminV2.commercial.topPagesSubtitle': 'Most visited pages',
  'adminV2.commercial.views': 'views',
  'adminV2.commercial.noPageData': 'No page data available',
  'adminV2.commercial.good': 'Good',
  'adminV2.commercial.needsImprovement': 'Needs Improvement',
  'adminV2.commercial.poor': 'Poor',
  'adminV2.commercial.noData': 'No data',

  // Admin V2 Users Page
  'adminV2.users.title': 'Users & Subscriptions',
  'adminV2.users.subtitle': 'Manage users and billing',
  'adminV2.users.refresh': 'Refresh',
  'adminV2.users.search': 'Search by email or organization...',
  'adminV2.users.totalUsers': 'Total Users',
  'adminV2.users.onTrial': 'On Trial',
  'adminV2.users.activePaid': 'Active Paid',
  'adminV2.users.pastDue': 'Past Due',
  'adminV2.users.filterAll': 'All',
  'adminV2.users.filterTrial': 'Trial',
  'adminV2.users.filterActive': 'Active',
  'adminV2.users.filterPastDue': 'Past Due',
  'adminV2.users.email': 'Email',
  'adminV2.users.organization': 'Organization',
  'adminV2.users.status': 'Status',
  'adminV2.users.tier': 'Tier',
  'adminV2.users.joined': 'Joined',
  'adminV2.users.loading': 'Loading users...',
  'adminV2.users.noUsers': 'No users found',

  // Admin V2 Profiles Page
  'adminV2.profiles.title': 'Client Profiles',
  'adminV2.profiles.subtitle': 'Manage profiles & relaunch matching',
  'adminV2.profiles.search': 'Search by company, NAF code, email...',
  'adminV2.profiles.company': 'Company',
  'adminV2.profiles.nafCode': 'NAF Code',
  'adminV2.profiles.department': 'Department',
  'adminV2.profiles.owner': 'Owner',
  'adminV2.profiles.dataQuality': 'Data Quality',
  'adminV2.profiles.lastMatch': 'Last Match',
  'adminV2.profiles.actions': 'Actions',
  'adminV2.profiles.never': 'Never',
  'adminV2.profiles.loading': 'Loading profiles...',
  'adminV2.profiles.noProfiles': 'No profiles found',
  'adminV2.profiles.qualityGood': 'Good',
  'adminV2.profiles.qualityPartial': 'Partial',
  'adminV2.profiles.qualityPoor': 'Poor',
  'adminV2.profiles.matchingRelaunched': 'Matching relaunched',
  'adminV2.profiles.matchingRecalculated': 'Profile matching has been recalculated.',
  'adminV2.profiles.matchingError': 'Failed to relaunch matching.',

  // Admin V2 Data Page
  'adminV2.data.title': 'Data Quality & Scrapers',
  'adminV2.data.subtitle': 'Monitor data sources and quality',
  'adminV2.data.totalSubsidies': 'Total Subsidies',
  'adminV2.data.dataCompleteness': 'Data Completeness',
  'adminV2.data.expiredSubsidies': 'Expired Subsidies',
  'adminV2.data.brokenUrls': 'Broken URLs',
  'adminV2.data.dataSources': 'Data Sources',
  'adminV2.data.scraperStatus': 'Scraper status and controls',
  'adminV2.data.lastRun': 'Last run',
  'adminV2.data.neverRun': 'Never run',
  'adminV2.data.records': 'records',
  'adminV2.data.runNow': 'Run Now',
  'adminV2.data.failed': 'Failed',
  'adminV2.data.fieldCompleteness': 'Field Completeness',
  'adminV2.data.fieldCompletenessDesc': 'Percentage of subsidies with each field populated',
  'adminV2.data.scraperStarted': 'Scraper started',
  'adminV2.data.scraperTriggered': 'scraper has been triggered.',
  'adminV2.data.scraperError': 'Failed to start scraper.',

  // Admin V2 Health Page
  'adminV2.health.title': 'System Health',
  'adminV2.health.lastUpdated': 'Last updated',
  'adminV2.health.allOperational': 'All Systems Operational',
  'adminV2.health.someDegraded': 'Some Systems Degraded',
  'adminV2.health.issuesDetected': 'System Issues Detected',
  'adminV2.health.servicesHealthy': 'of {total} services healthy',
  'adminV2.health.subsidies': 'Subsidies',
  'adminV2.health.profiles': 'Profiles',
  'adminV2.health.uptime': 'Uptime',
  'adminV2.health.activeUsers': 'Active Users',
  'adminV2.health.services': 'Services',
  'adminV2.health.serviceStatus': 'Individual service status',
  'adminV2.health.latency': 'Latency',
  'adminV2.health.healthy': 'Healthy',
  'adminV2.health.degraded': 'Degraded',
  'adminV2.health.down': 'Down',
  'adminV2.health.quickActions': 'Quick Actions',
  'adminV2.health.commonTasks': 'Common administrative tasks',
  'adminV2.health.supabaseDashboard': 'Supabase Dashboard',
  'adminV2.health.vercelDashboard': 'Vercel Dashboard',
  'adminV2.health.postHog': 'PostHog',

  // Admin V2 Content Page - LinkedIn Post Orchestrator
  'adminV2.content.title': 'LinkedIn Post Orchestrator',
  'adminV2.content.subtitle': 'Generate and manage marketing posts',
  'adminV2.content.totalPosts': 'Total Posts',
  'adminV2.content.drafts': 'Drafts',
  'adminV2.content.published': 'Published',
  'adminV2.content.publishedThisMonth': 'Published This Month',
  'adminV2.content.generateSubsidy': 'Generate Subsidy Post',
  'adminV2.content.generateFeature': 'Generate Feature Post',
  'adminV2.content.selectSubsidy': 'Select a Subsidy',
  'adminV2.content.selectFeature': 'Select a Feature',
  'adminV2.content.tone': 'Tone',
  'adminV2.content.toneEngaging': 'Engaging',
  'adminV2.content.toneProfessional': 'Professional',
  'adminV2.content.toneEducational': 'Educational',
  'adminV2.content.generate': 'Generate with AI',
  'adminV2.content.generating': 'Generating...',
  'adminV2.content.regenerate': 'Regenerate',
  'adminV2.content.copyToClipboard': 'Copy to Clipboard',
  'adminV2.content.copied': 'Copied!',
  'adminV2.content.markPublished': 'Mark as Published',
  'adminV2.content.delete': 'Delete',
  'adminV2.content.view': 'View',
  'adminV2.content.status.draft': 'Draft',
  'adminV2.content.status.published': 'Published',
  'adminV2.content.status.archived': 'Archived',
  'adminV2.content.type.subsidy': 'Subsidy Highlight',
  'adminV2.content.type.feature': 'Platform Feature',
  'adminV2.content.noPostsYet': 'No posts yet. Generate your first one!',
  'adminV2.content.filterByType': 'Filter by type',
  'adminV2.content.filterByStatus': 'Filter by status',
  'adminV2.content.allTypes': 'All Types',
  'adminV2.content.allStatuses': 'All Statuses',
  'adminV2.content.refresh': 'Refresh',
  'adminV2.content.generatedPosts': 'Generated Posts',

} as const;